import { PopulationFilter } from '@digital-twins/shared-types'

import { ThreadCommandSeed } from './ThreadCommandMenu'

/**
 * Build a ThreadCommandMenu seed for a plan workflow Start (or Retry).
 *
 * Prefer `slug` so lobby templates (e.g. `morning-digest`) and
 * thread-actions resolve the same confirm path. Never open WorkflowMenu from
 * a plan — that path is confirm-less arm only.
 *
 * Plan / NL seeds always `forceConfirm`. They do **not** apply remembered
 * audience (that is how a leftover panel like Snacks Eaters landed on a
 * Financial Advisors brief). Prefill only from `audience` token or a unique
 * name in `audienceHint`.
 *
 * `rest` carries the latest user ask (or plan step `why` fallback) into the
 * template's first text input — same as typing `/test <sentence>`.
 */
export function buildPlanWorkflowCommandSeed(
  slug: string,
  previousNonce = 0,
  rest = '',
  audience = '',
  audienceHint = '',
  segment?: {
    populationFilter?: PopulationFilter
    segmentLabel?: string
  },
): ThreadCommandSeed {
  const seed: ThreadCommandSeed = {
    slug,
    rest,
    nonce: previousNonce + 1,
    forceConfirm: true,
  }
  const trimmedAudience = audience.trim()
  if (trimmedAudience) {
    seed.audience = trimmedAudience
  }
  const trimmedHint = audienceHint.trim()
  if (trimmedHint) {
    seed.audienceHint = trimmedHint
  }
  if (segment?.populationFilter) {
    seed.populationFilter = segment.populationFilter
  }
  const segmentLabel =
    typeof segment?.segmentLabel === 'string' ? segment.segmentLabel.trim() : ''
  if (segmentLabel) {
    seed.segmentLabel = segmentLabel
  }
  return seed
}
